import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popup, Segment } from 'semantic-ui-react';
import MessageSeverity from '@constants/messageSeverity';
import styles from './ValidationMessage.module.scss';

type ValidationMessageType = {
  key: string;
  messageVars: Map<string, string | number>;
  severity: MessageSeverity;
};

function ValidationMessage({
  validationMessageOld,
  validationMessageJson,
}: {
  validationMessageOld: string | undefined;
  validationMessageJson: string | undefined;
}) {
  const { t } = useTranslation();

  if (validationMessageOld) {
    return <div dangerouslySetInnerHTML={{ __html: validationMessageOld }} />;
  }

  if (!validationMessageJson) {
    return null;
  }

  const translateMessageVars = (messageVars: Map<string, string | number>) => {
    const translatedMessageVars: Map<string, string | number> = new Map();
    Object.entries(messageVars).forEach(([key, value]) => {
      const valuesArray = value.toString().split(',');
      translatedMessageVars.set(key, valuesArray.map((messageVarValue: string | number) => t(messageVarValue.toString().trim())));
    });
    return Object.fromEntries(translatedMessageVars);
  };

  const styledMessage = (validationMessage: ValidationMessageType[]) => (
    <Segment basic className={styles.messageContainer}>
      {validationMessage.map(message => {
        const translatedMessageVars = translateMessageVars(message.messageVars);
        return (
          <div
            key={message.key}
            className={message.severity === MessageSeverity.ERROR ? styles.error : styles.warning}
          >
            {t(message.key, translatedMessageVars)}
          </div>
        );
      })}
    </Segment>
  );

  try {
    const validationMessage: ValidationMessageType[] = JSON.parse(`[${validationMessageJson}]`);
    return (
      <Popup
        content={styledMessage(validationMessage)}
        trigger={styledMessage(validationMessage)}
      />
    );
  } catch (e) {
    return <>Error parsing JSON!</>;
  }
}

export default ValidationMessage;
